import { render, staticRenderFns } from "./PickTest.vue?vue&type=template&id=0afc1844&scoped=true&"
import script from "./PickTest.vue?vue&type=script&lang=js&"
export * from "./PickTest.vue?vue&type=script&lang=js&"
import style0 from "./PickTest.vue?vue&type=style&index=0&id=0afc1844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc1844",
  null
  
)

export default component.exports